import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Select from 'react-select'

import Header from '../../components/header/Header';
import PeopleExport from '../../components/exports/People';

import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';
import TypeOfPersonSelect from '../../components/shared/TypeOfPersonSelect';
import { debounce, optionalParam, buildParams } from '../../utilities/Generic.js'
import { request, handleRequestErrors } from '../../helpers/Requests.js';

class ExportsPeople extends Component {
  static TIME_COLUMNS = ["last_login", "updated_at", "covid_pass_expiry_date"];

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
    this.handleSortChange = this.handleSortChange.bind(this);
    this.handlePartialChange = this.handlePartialChange.bind(this);
    this.debouncedHandleSearch = debounce(this.handleSearch.bind(this), 500);
  }

  state = {
    location: "",
    type_of_person: "",
    custom_attribute_ids: [],
    tag_ids: [],
    page: 1,
    sort: "first_name",
    direction: "asc",
    search: "",
    custom_attribute_search: "",

    refresh_location: "",
    refresh_type_of_person: "",
    refresh_tag_ids: [],
    refresh_page: 1,
    refresh_sort: "first_name",
    refresh_direction: "asc",
    refresh_search: "",
    refresh_custom_attribute_search: "",

    locations: [],
    custom_attributes: [],
    tags: [],
    locationsLoaded: false,
    customAttributesLoaded: false,
    tagsLoaded: false,
    key: 0,
    unauthorized: "",
  };

  handleChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({
      [name]: value,
      key: Math.random(),
      page: 1
    });

    let url = {
      location: this.state.location,
      type_of_person: this.state.type_of_person,
      tag_ids: this.state.tag_ids
    }

    url[name] = value

    const params = buildParams(
      optionalParam("location", url.location),
      optionalParam("type", url.type_of_person),
      optionalParam("tag_ids", url.tag_ids),
      optionalParam("search", this.state.search),
      optionalParam("custom_attribute_search", this.state.custom_attribute_search),
      this.customAttributeHistoryBuilder(this.state.custom_attribute_ids),
      `page=1&sort=${this.state.sort}&direction=${this.state.direction}`
    )

    this.props.history.push(`/exports/people?${params}`);
  }

  handleMultiSelectChange(data) {
    const fakeEvent = {}
    fakeEvent.target = {}
    fakeEvent.target.name = "tag_ids"
    fakeEvent.target.value = data.map(option => option.value);

    this.handleChange(fakeEvent)
  }

  handleMultiCheckbox(event) {
    const name = parseInt(event.target.name);
    const value = event.target.checked;

    const custom_attribute_ids = this.state.custom_attribute_ids

    if (value === true) {
      if (!custom_attribute_ids.includes(name)) {
        custom_attribute_ids.push(name)
      }
    }
    else if (value === false) {
      if (custom_attribute_ids.includes(name)) {
        const index = custom_attribute_ids.indexOf(name)
        custom_attribute_ids.splice(index, 1)
      }
    }

    this.setState({
      custom_attribute_ids: custom_attribute_ids,
      key: Math.random()
    });

    const params = buildParams(
      optionalParam("location", this.state.location),
      optionalParam("type", this.state.type_of_person),
      optionalParam("tag_ids", this.state.tag_ids),
      optionalParam("search", this.state.search),
      optionalParam("custom_attribute_search", this.state.custom_attribute_search),
      this.customAttributeHistoryBuilder(custom_attribute_ids),
      `page=${this.state.page}&sort=${this.state.sort}&direction=${this.state.direction}`
    )

    this.props.history.push(`/exports/people?${params}`);
  }

  customAttributeHistoryBuilder(custom_attribute_ids) {
    if (custom_attribute_ids.length > 0) {
      return `custom_attribute_ids=${custom_attribute_ids}`
    }
    else return ""
  }

  handlePreviousPage() {
    let value = parseInt(this.state.page) - 1
    this.setState({
      page: value,
      key: Math.random()
    });

    const params = buildParams(
      optionalParam("location", this.state.location),
      optionalParam("type", this.state.type_of_person),
      optionalParam("tag_ids", this.state.tag_ids),
      optionalParam("search", this.state.search),
      optionalParam("custom_attribute_search", this.state.custom_attribute_search),
      this.customAttributeHistoryBuilder(this.state.custom_attribute_ids),
      `page=${value}&sort=${this.state.sort}&direction=${this.state.direction}`
    )

    this.props.history.push(`/exports/people?${params}`);
  }

  handleNextPage() {
    let value = parseInt(this.state.page) + 1
    this.setState({
      page: value,
      key: Math.random()
    });

    const params = buildParams(
      optionalParam("location", this.state.location),
      optionalParam("type", this.state.type_of_person),
      optionalParam("tag_ids", this.state.tag_ids),
      optionalParam("search", this.state.search),
      optionalParam("custom_attribute_search", this.state.custom_attribute_search),
      this.customAttributeHistoryBuilder(this.state.custom_attribute_ids),
      `page=${value}&sort=${this.state.sort}&direction=${this.state.direction}`
    )

    this.props.history.push(`/exports/people?${params}`);
  }

  handleSortChange(attribute) {
    let sort = this.state.sort
    let direction = this.state.direction

    if (this.state.sort !== attribute) {
      sort = attribute
      direction = ExportsPeople.TIME_COLUMNS.includes(attribute) ? "desc" : "asc"
      this.setState({
        sort: attribute,
        direction: direction,
        page: 1,
        key: Math.random()
      });
    }
    else if (this.state.direction === "asc") {
      direction = "desc"
      this.setState({
        direction: direction,
        page: 1,
        key: Math.random()
      })
    }
    else {
      direction = "asc"
      this.setState({
        direction: direction,
        page: 1,
        key: Math.random()
      })
    }

    const params = buildParams(
      optionalParam("location", this.state.location),
      optionalParam("type", this.state.type_of_person),
      optionalParam("tag_ids", this.state.tag_ids),
      optionalParam("search", this.state.search),
      optionalParam("custom_attribute_search", this.state.custom_attribute_search),
      this.customAttributeHistoryBuilder(this.state.custom_attribute_ids),
      `page=1&sort=${sort}&direction=${direction}`
    )

    this.props.history.push(`/exports/people?${params}`);
  }

  handlePartialChange(event) {
    let name = event.target.name;
    let value = event.target.value;

    this.setState({[name]: value});

    this.debouncedHandleSearch()

    // This stops getDerivedStateFromProps using params to override this state change when typing immediately after hitting back/forward
    this.props.history.action = "PUSH"
  }

  handleSearch() {
    this.setState({
      page: 1,
      key: Math.random()
    })

    const params = buildParams(
      optionalParam("location", this.state.location),
      optionalParam("type", this.state.type_of_person),
      optionalParam("tag_ids", this.state.tag_ids),
      optionalParam("search", this.state.search),
      optionalParam("custom_attribute_search", this.state.custom_attribute_search),
      this.customAttributeHistoryBuilder(this.state.custom_attribute_ids),
      `page=1&sort=${this.state.sort}&direction=${this.state.direction}`
    )

    this.props.history.push(`/exports/people?${params}`);
  }

  renderCustomAttributes() {
    const custom_attributes = this.state.custom_attributes
    const custom_attribute_ids = this.state.custom_attribute_ids

    if (custom_attributes.length > 0 && localStorage.license === "base") {
      return (
        <div className="selection-block">
          Display Custom Attributes:
          {custom_attributes.map((custom_attribute) => (
            <div className="selection-block right-label" key={"custom_attribute_"+custom_attribute.id}>
              <input className="clickable" type="checkbox" id={custom_attribute.id} name={custom_attribute.id} key={"custom_attribute_"+custom_attribute.id} checked={custom_attribute_ids.includes(custom_attribute.id)} onChange={this.handleMultiCheckbox} />
              <label className="clickable" htmlFor={custom_attribute.id} key={custom_attribute.name}>{custom_attribute.name}</label>
            </div>
          ))}
        </div>
      )
    }
  }

  render() {
    const { date_from, date_to, location, type_of_person, tag_ids, search, custom_attribute_search, custom_attribute_ids, locations, custom_attributes, tags, locationsLoaded, customAttributesLoaded, tagsLoaded, unauthorized, error, page, sort, direction } = this.state;
    const { match: { params } } = this.props;

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (locationsLoaded === false || customAttributesLoaded === false || tagsLoaded === false) {
      return (
        <div>
          <SetTitle title={"Export People | Exports"} />
          <Header />

          <div className="main-page">
            <h2 className="page-title">Export People</h2>
            <OrganisationName />

            <p>Loading ...</p>
          </div>
        </div>
      )
    }

    const baseLicense = localStorage.license === "base"

    const selectOptions = tags.map(tag => ({ value: tag.id, label: tag.name }))
    const selectedTags = selectOptions.filter(option => tag_ids.includes(option.value))

    return (
      <div>
        <SetTitle title={"Export People | Exports"} />
        <Header />

        <div className="main-page">
          <h2 className="page-title">Export People</h2>
          <OrganisationName />


          <div className="export-selection">
            <div className="selection-block">
              <label className="column">Location:</label>
              <select name="location" value={location} onChange={this.handleChange} data-testid="select-locations">
                <option value="">All</option>
                {locations.map((location) => (
                  <option value={location.id} key={location.id}>{location.name}</option>
                ))}
              </select>
            </div>

            <div className="selection-block">
              <label className="column">Type:</label>
              <TypeOfPersonSelect defaultText="All" value={type_of_person} onChange={this.handleChange} />
            </div>

            <div className="selection-block">
              <label className="column">Search by Name:</label>
              <input type="text" name="search" value={search} onChange={this.handlePartialChange} />
            </div>

            {baseLicense && (
              <div className="selection-block">
                <label className="column">Filter by Tags:</label>
                <Select onChange={this.handleMultiSelectChange} options={selectOptions} value={selectedTags} isMulti={true} unstyled={true} className="react-select" classNamePrefix="react-select" placeholder={"All"} />
              </div>
            )}

            {baseLicense && (
              <div className="selection-block">
                <label className="column">Search by Custom Attributes:</label>
                <input type="text" name="custom_attribute_search" value={custom_attribute_search} onChange={this.handlePartialChange} />
              </div>
            )}

            {this.renderCustomAttributes()}
          </div>

          <PeopleExport date_from={date_from} date_to={date_to} selected_location={location} type_of_person={type_of_person} tag_ids={tag_ids} search={search} custom_attribute_search={custom_attribute_search} custom_attribute_ids={custom_attribute_ids} custom_attributes={custom_attributes} key={this.state.key + 1} id={params.id} page={page} handleNextPage={this.handleNextPage} handlePreviousPage={this.handlePreviousPage} sort={sort} direction={direction} handleSortChange={this.handleSortChange} />

        </div>

      </div>
    );
  }

  static getDerivedStateFromProps(props, state) {
    if (props.location.search === "" && props.location.pathname.endsWith("/people")) {
      props.history.replace(`/exports/people?page=${state.refresh_page}&sort=${state.refresh_sort}&direction=${state.refresh_direction}`);

      return {
        location: state.refresh_location,
        type_of_person: state.refresh_type_of_person,
        tag_ids: state.refresh_tag_ids,
        custom_attribute_ids: [],
        search: state.refresh_search,
        visited_person_search: state.refresh_custom_attribute_search,
        page: state.refresh_page,
        sort: state.refresh_sort,
        direction: state.refresh_direction,
        key: Math.random()
      }
    }
    else {
      // handle back/forward buttons
      if (props.history.action === "POP" && props.history.location.search !== "") {
        const params = new URLSearchParams(props.history.location.search)
        let location = params.get('location') || ""
        let type_of_person = params.get('type') || ""
        let tag_ids = params.get('tag_ids')?.split(",").map(id => parseInt(id)) || []
        let custom_attribute_ids = params.get('custom_attribute_ids')?.split(",").map(id => parseInt(id)) || []

        for (let index = 0; index < custom_attribute_ids.length; index++) {
          custom_attribute_ids[index] = parseInt(custom_attribute_ids[index])
        }

        let search = params.get('search') || ""
        let custom_attribute_search = params.get('custom_attribute_search') || ""

        let page = params.get('page')
        let sort = params.get('sort')
        let direction = params.get('direction')

        return {
          location: location,
          type_of_person: type_of_person,
          tag_ids: tag_ids,
          custom_attribute_ids: custom_attribute_ids,
          search: search,
          custom_attribute_search: custom_attribute_search,
          page: page,
          sort: sort,
          direction: direction,
          key: Math.random()
        }
      }
      else {
        return null
      }
    }
  }

  componentDidMount() {
    // deep link params
    if (this.props.location.search !== "") {
      const params = new URLSearchParams(this.props.location.search)

      // grab query param or set default value
      const location = params.get('location') || ""
      const type_of_person = params.get('type') || ""
      const tag_ids = params.get('tag_ids')?.split(",").map(id => parseInt(id)) || []
      const custom_attribute_ids = params.get('custom_attribute_ids')?.split(",").map(id => parseInt(id)) || []
      const search = params.get('search') || ""
      const custom_attribute_search = params.get('custom_attribute_search') || ""
      const page = params.get('page') || 1
      const sort = params.get('sort') || "first_name"
      const direction = params.get('direction') || "asc"

      for (let index = 0; index < custom_attribute_ids.length; index++) {
        custom_attribute_ids[index] = parseInt(custom_attribute_ids[index])
      }

      // set history in case one of the params was missing
      const builtParams = buildParams(
        optionalParam("location", location),
        optionalParam("type", type_of_person),
        optionalParam("tag_ids", tag_ids),
        optionalParam("search", search),
        optionalParam("custom_attribute_search", custom_attribute_search),
        this.customAttributeHistoryBuilder(custom_attribute_ids),
        `&page=${page}&sort=${sort}&direction=${direction}`
      )

      this.props.history.replace(`/exports/people?${builtParams}`);

      this.setState({
        location: location,
        type_of_person: type_of_person,
        tag_ids: tag_ids,
        custom_attribute_ids: custom_attribute_ids,
        search: search,
        custom_attribute_search: custom_attribute_search,
        page: page,
        sort: sort,
        direction: direction,
        key: Math.random()
      });
    }

    // normal API fetching stuff
    request("GET", `/v1/a/locations/names_and_ids`, "", () => {this.setState({unauthorized: true})})
      .then(data => {this.setState({ locations: data, locationsLoaded: true })})
      .catch(error => handleRequestErrors(this, error, { locationsLoaded: true }))

    if (localStorage.license === "base") {
      request("GET", `/v1/a/custom_attributes/names_and_ids`, "", () => {this.setState({unauthorized: true})})
        .then(data => {this.setState({ custom_attributes: data, customAttributesLoaded: true })})
        .catch(error => handleRequestErrors(this, error, { customAttributesLoaded: true }))

      request("GET", `/v1/a/tags/names_and_ids`, "", () => {this.setState({unauthorized: true})})
        .then(data => {this.setState({ tags: data, tagsLoaded: true })})
        .catch(error => handleRequestErrors(this, error, { tagsLoaded: true }))
    }
    else {
      this.setState({
        tags: [],
        custom_attributes: [],
        tagsLoaded: true,
        customAttributesLoaded: true
      })
    }
  }
}

export default ExportsPeople;
